import { useEffect } from 'react';
import Mousetrap from 'mousetrap';
export function useKeyboardShortcuts(keyboardShortcuts, data) {
  function bindKeyboardShortcuts() {
    if (keyboardShortcuts) {
      Object.keys(keyboardShortcuts).forEach(function (key) {
        return Mousetrap.bind(key, keyboardShortcuts[key].bind(null, data));
      });
    }
  }

  function unbindKeyboardShortcuts() {
    if (keyboardShortcuts) {
      Object.keys(keyboardShortcuts).forEach(function (key) {
        return Mousetrap.unbind(key);
      });
    }
  }

  useEffect(function () {
    return function () {
      unbindKeyboardShortcuts();
    };
  }, []);
  return {
    bindKeyboardShortcuts: bindKeyboardShortcuts,
    unbindKeyboardShortcuts: unbindKeyboardShortcuts
  };
}